"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.random = void 0;
var characters_const_1 = require("../consts/characters.const");
exports.random = {
    aToB: function (a, b) {
        if (a === void 0) { a = 0; }
        if (b === void 0) { b = 1; }
        return Math.floor(Math.random() * (b - a + 1) + a);
    },
    string: function (size, characters) {
        if (size === void 0) { size = 8; }
        if (characters === void 0) { characters = characters_const_1.CHARACTERS; }
        return Array.apply(null, Array(size)).map(function () {
            return exports.random.fromArray(characters.split(''));
        }).join('');
    },
    fromArray: function (list) {
        return list[Math.floor(Math.random() * list.length)];
    },
    bool: function () {
        return Math.random() >= 0.5;
    },
    int: function (a, b) {
        if (a === void 0) { a = 0; }
        if (b === void 0) { b = 10; }
        return exports.random.aToB(a, b);
    },
    float: function (a, b) {
        if (a === void 0) { a = 0; }
        if (b === void 0) { b = 1; }
        return Math.random() * (b - a) + a;
    }
};
